import QubicaFooter from '@redturtle/qubicaamf-theme/components/Footer/Footer';

const Footer = () => {
  return <QubicaFooter />;
};

export default Footer;
